<template>
  <sidenav
    :orientation="orientation"
    :class="curClasses"
  >
    <!-- Inner -->
    <div
      class="sidenav-inner"
      :class="{ 'py-1': orientation !== 'horizontal' }"
    >
      <sidenav-router-link
        v-if="$store.getters['authorization/isVolunteer']"
        icon="ion ion-ios-contact"
        to="/"
        :exact="true"
      >
        {{ $t('menu.sidebar.expense') }}
      </sidenav-router-link>
      <sidenav-router-link
        v-if="$store.getters['authorization/isApproving'] || $store.getters['authorization/isEncoder']"
        icon="ion ion-md-desktop"
        to="/approbation"
        :exact="true"
      >
        {{ $t('menu.sidebar.approbation') }}
      </sidenav-router-link>
      <sidenav-router-link
        v-if="$store.getters['authorization/isAdministrator'] || $store.getters['authorization/isApproving']"
        icon="ion ion-md-apps"
        to="/dashboardApproving"
        :exact="true"
      >
        {{ $t('menu.sidebar.dashboard') }}
      </sidenav-router-link>
      <sidenav-router-link
        icon="ion ion-md-help"
        to="/faq"
        :exact="true"
      >
        {{ $t('menu.sidebar.faq') }}
      </sidenav-router-link>
      <sidenav-menu
        v-if="$store.getters['authorization/isAdministrator'] || $store.getters['authorization/isApproverAdm']"
        icon="ion ion-md-settings"
      >
        <template slot="link-text">
          {{ $t('menu.sidebar.administration') }}
        </template>
        <sidenav-router-link
          v-if="$store.getters['authorization/isAdministrator']"
          icon="ion ion-md-apps"
          to="/administration"
          :exact="true"
        >
          {{ $t('menu.sidebar.dashboard') }}
        </sidenav-router-link>
        <sidenav-router-link
          v-if="$store.getters['authorization/isAdministrator'] || $store.getters['authorization/isApproverAdm']"
          icon="ion ion-md-people"
          to="/users"
          :exact="true"
        >
          {{ $t('menu.sidebar.users') }}
        </sidenav-router-link>
        <sidenav-router-link
          v-if="$store.getters['authorization/isAdministrator']"
          icon="ion ion-md-options"
          to="/parameters"
          :exact="true"
        >
          {{ $t('menu.sidebar.parameters') }}
        </sidenav-router-link>
        <sidenav-router-link
          v-if="$store.getters['authorization/isAdministrator']"
          icon="ion ion-md-bicycle"
          to="/activities"
          :exact="true"
        >
          {{ $t('menu.sidebar.activities') }}
        </sidenav-router-link>
        <sidenav-router-link
          v-if="$store.getters['authorization/isAdministrator']"
          icon="ion ion-md-business"
          to="/entities"
          :exact="true"
        >
          {{ $t('menu.sidebar.entities') }}
        </sidenav-router-link>
        <sidenav-router-link
          v-if="$store.getters['authorization/isAdministrator']"
          icon="ion ion-md-construct"
          to="/prestations"
          :exact="true"
        >
          {{ $t('menu.sidebar.prestations') }}
        </sidenav-router-link>
        <sidenav-router-link
          v-if="$store.getters['authorization/isAdministrator']"
          icon="ion ion-md-mail"
          to="/messages"
          :exact="true"
        >
          {{ $t('menu.sidebar.messages') }}
        </sidenav-router-link>
        <sidenav-router-link
          v-if="$store.getters['authorization/isAdministrator']"
          icon="ion ion-md-pulse"
          to="/audits"
          :exact="true"
        >
          {{ $t('menu.sidebar.audits') }}
        </sidenav-router-link>
      </sidenav-menu>
    </div>
  </sidenav>
</template>

<script>
import {
  Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider,
} from '@/vendor/libs/sidenav';

export default {
  name: 'AppLayoutSidenav',
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider,
    /* eslint-enable vue/no-unused-components */
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical',
    },
  },

  computed: {
    curClasses() {
      let bg = this.layoutSidenavBg;

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '');
      }

      return `bg-${bg} ${this.orientation !== 'horizontal'
        ? 'layout-sidenav'
        : 'layout-sidenav-horizontal container-p-x flex-grow-0'}`;
    },
  },

  methods: {
    isMenuActive(url) {
      return this.$route.path.indexOf(url) === 0;
    },

    isMenuOpen(url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal';
    },

    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },
  },
};
</script>
